import { Construction } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/** A tab that is built but not yet opened. SDTD lifts the curtain from the control cockpit. */
export default function ComingSoon({ screen, label }) {
  const { curtains } = useAuth();
  return (
    <div className="p-5 sm:p-8" data-testid={`coming-soon-${screen}`}>
      <div className="label-caps flex items-center gap-2 text-primary">
        <Construction className="h-3.5 w-3.5" /> Being readied
      </div>
      <h1 className="mt-2 font-display text-3xl font-black tracking-tight sm:text-4xl">
        {label || "This part of the portal"} — coming soon
      </h1>
      <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground">
        {curtains?.[screen] ||
          "This part of the portal is being readied. SDTD will open it here shortly."}
      </p>
      <p className="mt-6 max-w-2xl border border-border bg-card p-4 text-xs text-muted-foreground">
        The tab stays in your menu so you know it is on the way. Nothing is missing from your
        account — SDTD has simply not opened this one yet.
      </p>
    </div>
  );
}
